import {
	createApp
} from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import axios from 'axios';
import wx from 'weixin-js-sdk'


import "./utils/system.js";
import {
	converterEx,
	isNullOrEmptyEx
} from "@/utils/sysPublic";

import {
	getCart,
	setCart,
	addCart,
	getToken,
	setToken,
	removeToken
} from"@/utils/auth.js";

const app = createApp(App)

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$wx = wx;

app.config.globalProperties.converterEx = converterEx;
app.config.globalProperties.isNullOrEmptyEx = isNullOrEmptyEx;

app.config.globalProperties.getCart = getCart;
app.config.globalProperties.setCart = setCart;
app.config.globalProperties.addCart = addCart;
app.config.globalProperties.getToken = getToken;
app.config.globalProperties.setToken = setToken;
app.config.globalProperties.removeToken = removeToken;

import Vue from 'vue'
import VueClipBoard from 'vue-clipboard2'


app.use(store)
	.use(router)
	.use(ViewUIPlus)
	.use(VueClipBoard)
	.mount('#app')
